import React, { useEffect, useState, useRef } from "react";
import { observer } from "mobx-react";
import { init } from "echarts";

import Color from "@/tool/color";
import { isEmpty } from "lodash";
import moWelfare, { changeMouse } from "../store/wealfare";
import { geoCoordMap } from "../../component/city";
import moIndex from "../../store";

interface IProps {}
interface IState {}
let echartdom: any = null;

const ChinaCityMap = (props: IProps, state: IState) => {
  const { WelfareCityRankDate } = moWelfare;
  const { isMock } = moIndex;
  const list = WelfareCityRankDate;
  const talentMap = useRef<any>(null);
  const getDataList: any = list?.map((item: any) => {
    const items: any = {};
    items.name = item.city;
    items.value = item.amount;
    return items;
  });

  const render = () => {
    // 地图数据
    if (echartdom) echartdom.dispose();
    echartdom = init(talentMap.current);
    // 后台返回数据
    const data = getDataList;
    const convertData = function (data: any[]) {
      const res = [];
      if (!isEmpty(data)) {
        for (let i = 0; i < data?.length; i += 1) {
          const geoCoord = geoCoordMap[data[i].name];
          if (geoCoord) {
            res.push({
              name: data[i].name,
              value: geoCoord.concat(data[i].value),
            });
          }
        }
      }
      return res;
    };

    const option = {
      backgroundColor: Color.white,
      tooltip: {
        trigger: "item",
        formatter(params: any) {
          const result: any = [];
          list?.forEach((item: any) => {
            result.push(item.city);
          });
          if (!result.includes(params.name)) {
            return "";
          }
          return `
                  <p>
                    <span
                      style="display:inline-block;
                      width:10px;height:10px;background:${params.color};
                      border-radius:50%;margin-right:5px">
                    </span>
                    <span style="fontFamily: 'PingFang SC'">${
                      params.name
                    }</span>
                    <span style="margin:0 15px"></span>
                    <span style="font-family: 'Roboto'">
                      ${Number(params.value[2]).toLocaleString()}
                    </span>
                  </p`;
        },
      },
      legend: {
        data: [],
      },
      visualMap: {
        min: 0,
        max: 40000,
        left: 20,
        bottom: 20,
        calculable: true,
        text: ["高", "低"],
        inRange: {
          color: [
            Color.primaryColor(0.5),
            Color.primaryColor(0.55),
            Color.primaryColor(0.6),
            Color.primaryColor(0.65),
            Color.primaryColor(0.7),
            Color.primaryColor(0.75),
            Color.primaryColor(0.8),
            Color.primaryColor(0.85),
            Color.primaryColor(0.9),
            Color.primaryColor(0.95),
          ],
        },
        // color: Color.parmary,
        textStyle: {
          color: Color.c000,
        },
        show: false,
      },
      geo: {
        map: "china",
        roam: "move",
        zoom: 1.2,
        itemStyle: {
          areaColor: Color.f0,
          borderColor: Color.white,
        },
        emphasis: {
          itemStyle: {
            areaColor: Color.f0,
          },
          label: {
            show: false,
          },
        },
      },
      series: [
        {
          name: "地图",
          type: "scatter",
          coordinateSystem: "geo",
          data: convertData(data),
          symbolSize(val: any) {
            return val[0] / 5;
          },
          label: {
            formatter: "{b}",
            show: false,
            color: Color.c000,
            fontSize: 14,
            fontFamily: "PingFang SC",
          },
          itemStyle: {
            color: Color.c000,
          },
          emphasis: {
            itemStyle: {
              borderColor: Color.white,
              borderWidth: 0,
              color: Color.white,
            },
            label: {
              show: true,
              color: Color.c000,
              fontFamily: "PingFang SC",
            },
          },
        },
        {
          type: "map",
          map: "china",
          geoIndex: 0,
          aspectScale: 0.75,
          silent: true,
          label: {
            show: false,
            emphasis: {
              show: false,
            },
          },
        },
      ],
    };
    echartdom.setOption(option, true);
    echartdom.on("mouseover", (params: any) => {
      changeMouse(params.name);
    });
    echartdom.on("mouseout", (params: any) => {
      changeMouse("");
    });
  };

  useEffect(() => {
    render();
    return () => {};
  }, [WelfareCityRankDate]);

  useEffect(() => {
    window.addEventListener("resize", render);
    return () => {
      window.removeEventListener("resize", render);
    };
  });

  return <section className="welfare-city-map-0091" ref={talentMap} />;
};

export default observer(ChinaCityMap);
